import React from 'react';
import Checkbox from '@tencent/dui/lib/components/Checkbox';
import style from './style.less';

interface CheckboxWithLabelProps {
    label: string;
    checked: boolean;
    onChange: () => void,
}

export const CheckboxWithLabel: React.FC<CheckboxWithLabelProps> = ({
    label, checked, onChange,
}) => (
    <Checkbox className={style['toolbar-checkbox-wrapper']} checked={checked} onChange={onChange}>
        {label}
    </Checkbox>
);
